
import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    list: []
  }

  // 任务列表
  @action async getTasksList() {
    let list = await http.post('/web/dailyTask/list')
    // console.log(list)
    if (list && list.code == 0) {
      this.data.list = list && list.res
      return list.res
    }
  }

  // 领取奖励
  @action async getReward(taskid) {
    let res = await http.post('/web/dailyTask/receive', { taskid })
    if (res && res.code == 0) {
      return res.res
    }
  }

}



// WEBPACK FOOTER //
// src/store/activity/tasks.js